<script>
  import Portal from "./Portal.svelte";
  import { pannable } from "../actions/pannable.js";

  export let top = 96;
  export let height = 48;

  $: topValue = typeof top === "number" ? `${top}px` : top;
  $: heightValue = typeof height === "number" ? `${height}px` : height;

  let translateX = 0;
  let translateY = 0;
  let startX = 0;
  let startY = 0;
  let initialTranslateX = 0;
  let initialTranslateY = 0;

  function handlePanStart(event) {
    startX = event.detail.x;
    startY = event.detail.y;
    initialTranslateX = translateX;
    initialTranslateY = translateY;
  }

  function handlePanMove(event) {
    translateX = initialTranslateX + (event.detail.x - startX);
    translateY = initialTranslateY + (event.detail.y - startY);
  }
</script>

<Portal>
  <div
    class="context-toolbar fixed inset-x-0 z-30 pointer-events-none"
    style="top: {topValue}; height: {heightValue};"
  >
    <div
      class="w-full h-full flex items-center justify-center pointer-events-auto"
      style="transform: translate({translateX}px, {translateY}px);"
    >
      <div
        class="flex items-stretch bg-white border border-gray-200 shadow-sm rounded-lg overflow-hidden"
      >
        <div
          use:pannable
          on:panstart={handlePanStart}
          on:panmove={handlePanMove}
          class="flex items-center justify-center px-1.5 bg-gray-50 border-r border-gray-200 cursor-grab hover:bg-gray-100 transition-colors active:cursor-grabbing"
          title="Drag to move toolbar"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-gray-400"
          >
            <circle cx="9" cy="5" r="1.5"></circle>
            <circle cx="9" cy="12" r="1.5"></circle>
            <circle cx="9" cy="19" r="1.5"></circle>
            <circle cx="15" cy="5" r="1.5"></circle>
            <circle cx="15" cy="12" r="1.5"></circle>
            <circle cx="15" cy="19" r="1.5"></circle>
          </svg>
        </div>

        <div class="px-2 py-1 flex items-center gap-2">
          <slot />
        </div>
      </div>
    </div>
  </div>
</Portal>
